<div *ngIf="isNonClients" data-testid="nonclient-list" class="nonclient-list">
  <header class="nonclient-list__header">
    <div class="nonclient-list__titles">
      <h4 class="nonclient-list__title">Not in Client Manager</h4>
      <p class="nonclient-list__subtitle">most recently active first</p>
    </div>
  </header>
  <div *ngIf="rows.length; else empty" class="nonclient-list__table-wrap">
    <table class="nonclient-list__table">
      <thead>
        <tr>
          <th>Company</th>
          <th>Source</th>
          <th class="nonclient-list__number">Active users</th>
          <th>Packages</th>
          <th>Last login</th>
          <th class="nonclient-list__number">XatBot spend (30d)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows" data-testid="nonclient-row">
          <td class="nonclient-list__name" [title]="row.companyId">{{ row.companyName }}</td>
          <td>{{ row.source || '—' }}</td>
          <td class="nonclient-list__number">{{ row.activeUsers }}</td>
          <td>
            <span class="nonclient-list__chips">
              <span *ngFor="let code of row.packageCodes | slice:0:maxChips" class="nonclient-list__chip">{{ code }}</span>
              <span *ngIf="row.packageCodes?.length > maxChips" data-testid="more-packages"
                    class="nonclient-list__chip nonclient-list__chip--more">+{{ row.packageCodes.length - maxChips }}</span>
            </span>
          </td>
          <td data-testid="last-login">{{ row.lastLogin ? (row.lastLogin | date:'d MMM y':'UTC') : 'Never' }}</td>
          <td class="nonclient-list__number">{{ row.spend30 | currency:'USD':'symbol':'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <p *ngIf="truncated" data-testid="nonclient-footer" class="nonclient-list__footer">
    Showing {{ rows.length }} of {{ total }}
  </p>
  <ng-template #empty>
    <app-admin-dashboard-empty *ngIf="failed" data-testid="nonclient-list-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
    <app-admin-dashboard-empty *ngIf="loaded && !failed" data-testid="empty" icon="fa-regular fa-building" [compact]="true"
                               [title]="'No non-client companies yet'"></app-admin-dashboard-empty>
  </ng-template>
</div>
